import React, { useEffect, useState } from 'react'
import { Modal, Button, FormGroup, FormControl, Label } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { IOperation } from 'plugin-codaf-risk-ext-bowtie/types'

import { AbsoluteLoading, RoundedModal } from '../../../../../generic'
import { CreateEditOperationModalContainer } from './styles'

interface IProps {
    show: boolean
    setShow: (k: boolean) => void
    type: 'create' | 'edit'
    handleClose: () => void
    operation?: IOperation
    setOperation?: (k: IOperation) => void
    handleCreate?: (k: string) => Promise<void>
    handleUpdate?: (k: IOperation) => Promise<void>
}

export const CreateEditOperationModal: React.FC<IProps> = ({
    show,
    setShow,
    type,
    handleClose,
    operation,
    handleCreate,
    handleUpdate,
    setOperation
}) => {
    const [operationName, setOperationName] = useState<string>('')

    const onSave = async (): Promise<void> => {
        if (type === 'create') {
            await handleCreate(operationName)
        } else {
            const updatedOperation: IOperation = { id: operation.id, description: operationName }

            await handleUpdate(updatedOperation)
        }

        setOperationName('')
        handleClose()
    }

    const onClose = (): void => {
        setOperationName('')
        handleClose()
    }

    const openProtocol = (): void => {
        if (type === 'edit') {
            setOperationName(operation?.description)
        }
    }

    useEffect(() => {
        openProtocol()
    }, [operation])

    return (
        <CreateEditOperationModalContainer>
            <RoundedModal show={show} onHide={onClose} aria-labelledby="contained-modal-title">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">
                        {type === 'create' ? i18n('New Operation') : i18n('Edit Operation')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <span style={{ fontSize: 13, fontWeight: 600 }}>{i18n('Operation name')}</span>
                        <FormControl
                            type={'text'}
                            onChange={e => {
                                setOperationName((e.target as HTMLInputElement).value)
                            }}
                            className={'modal-input'}
                            value={operationName}
                        />
                        <span style={{ fontSize: 12, fontWeight: 400, color: 'var(--gray-700)' }}>
                            {i18n('The name is used to identify the operation.')}
                        </span>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="no-outline-button"
                        bsStyle="primary"
                        onClick={onSave}
                        style={{ borderRadius: 3, marginRight: 8 }}
                        id="diagramList-list-button-newDiagram"
                        disabled={!operationName || operationName.length === 0}
                    >
                        {i18n('Save')}
                    </Button>
                    <Button
                        className="no-outline-button"
                        onClick={onClose}
                        style={{ borderRadius: 3, marginRight: 8 }}
                        id="diagramList-list-button-newDiagram"
                    >
                        {i18n('Close')}
                    </Button>
                </Modal.Footer>
            </RoundedModal>
        </CreateEditOperationModalContainer>
    )
}
